import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { doDeleteDraft, openCloseModalContinue, loadBorradorAgenda } from "./actions";
import moment from "moment"
import { formatDateForFilter } from "../../../../../helpers/dateFormat";

class ModalEliminarBorrador extends React.PureComponent {
  handleClose = () => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    const { onOpen, onSetDataSolicitudAgenda } = this.props;
    onOpen(false, _data, {});
    onSetDataSolicitudAgenda(_data);
  }

  handleDelete = () => {
    const data = {
      from: formatDateForFilter(moment().subtract(1, "year")),
      to: formatDateForFilter(moment()),
      companyRut: this.props.companyId,
      PetitionerRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    
    this.props.dispatch(doDeleteDraft(this.props.idSelected, data))
  }

  handleCerrar = () => {
    this.props.dispatch(openCloseModalContinue(false, null))
  }

  handleOpenDraft = () => {
    this.props.dispatch(loadBorradorAgenda(this.props.idSelected, this.props.companyId));
  }
  
  render() {
    
    return (
      <Popup
        visible={this.props.isOpenModalContinue}
        dragEnabled={false}
        maxHeight="200px"
        onHiding={() => this.handleCerrar()}
        maxWidth="500px"
        title="Borrador"
        showTitle
        contentComponent={React.memo((Props) => (
          <React.Fragment>
            <div className="col-12" style={{ justifyContent: "center" }}>
              <div style={{ width: "100%", textAlign: "center" }}>
                <p> ¿Deseas continuar con la solicitud en curso o descartar el borrador y eliminar sus datos? </p>
              </div>
            </div>
            <div className="col-12" style={{ marginTop: 20 }} >
              <Button
                text="Descartar borrador"
                className="delete-button-outline"
                type="normal"
                onClick={() => this.handleDelete(true)}
                disabled={this.props.isLoading}
              />
              <Button
                text="Continuar Borrador"
                type="success"
                onClick={this.handleOpenDraft}
                style={{ float: "right" }}
                disabled={this.props.isLoading}
              />
            </div>
          </React.Fragment>
        ))}
      />
    );
  }
}
const mapStateToProps = (state) => ({
  isOpenModalContinue: state.solicitudesAgendaSel.isOpenModalContinue,
  idSelected: state.solicitudesAgendaSel.idSelected,
  isLoading: state.solicitudesAgendaSel.isLoading,
  companyId: state.global.companyId,
  userData: state.global.userData,
  selectedTipoSolicitud: state.solicitudesAgendaSel.selectedTipoSolicitud,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});
export default connect(mapStateToProps, mapDispatchToProps)(ModalEliminarBorrador);
